import { render, staticRenderFns } from "./OnlineAvailability.vue?vue&type=template&id=28a5a03e&"
import script from "./OnlineAvailability.vue?vue&type=script&lang=js&"
export * from "./OnlineAvailability.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports